// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__X9c25","dragIcon":"Choice_dragIcon__2DpBK","left":"Choice_left__2gPuK","input":"Choice_input__rws6J"};